import cn from "classnames";
import { ImageBody, renderDownloadLink } from "components/shared/fileBody";
import format from "date-fns/format";
import isToday from "date-fns/isToday";
import { imageExtensions } from "helpers/system";
import React from "react";
import Linkify from "react-linkify";

export default function ChatMessage(props) {
    const renderFile = (file) => {
        const name = file.originalFileName;
        const url = file.accessUrlLink.replace(name, "");
        const accessUrlLink = file.accessUrlLink;
        if (imageExtensions.includes(file.extension)) {
            return <ImageBody key={file.id} name={name} url={url} accessUrlLink={accessUrlLink} />;
        }
        return (
            <div key={file.id} className="chat-msg__body chat-msg__body--file">
                <div className="chat-msg__body-icon" />
                <div className="chat-msg__body-text ellipsis" title={name}>
                    {name}
                </div>
                {renderDownloadLink(url, name)}
            </div>
        );
    };

    const createdAt = new Date(props.createdAt);

    return (
        <div
            className={cn("ts-chat__item", {
                "ts-chat__item--user": props.isUserMessage,
                "ts-chat__item--system": !props.isUserMessage,
            })}
        >
            <div className="ts-chat__item-wrap">
                {props.files?.map(renderFile)}
                {props.staffMemberFullName && (
                    <span className="text-muted ts-chat__item-sender">{props.staffMemberFullName}</span>
                )}
                <span className="text-muted ts-chat__item-time">
                    {format(createdAt, isToday(createdAt) ? "HH:mm" : "dd.MM.yyyy HH:mm")}
                </span>
                <Linkify properties={{ target: "_blank", rel: "nofollow noopener" }}>{props.content}</Linkify>
            </div>
        </div>
    );
}
